//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {
    tab: {
      default: ''
    }
  },
  data: () => ({
    search: {
      q: ''
    },
    table: [],
    // page: {
    //   pageNo: 1,
    //   pageSize: 10,
    //   total: 0
    // },
    loading: false
  }),
  components: {
    PageHeader: () => import('./components/PageHeader/index.vue'),
    PageMain: () => import('./components/PageMain/index.vue')
  },
  watch: {
    tab: {
      handler (val) {
        if (val && val == 'dealer') {
            this.handleLoadTableData()
        }
      },
      immediate: true
    }
  },
  mounted () {
  },
  methods: {
    handleLoadTableData () {
      this.loading = true
      let data = _.extend({}, this.search)
      //   data.pageNo = this.page.pageNo
      // data.pageSize = this.page.pageSize
      this.$axios.get('/mtea/store/admin/dealer/list', { params: data }).then(res => {
        // console.log('res', res)

        this.table = res
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
